module.exports = __webpack_public_path__ + "static/media/yellow.2a5f9b89.png";